import React from "react";
import HeaderOne from "./header/HeaderOne";
import FooterThree from "./footer/FooterThree";

const Layout = ({ children }) => {
  return (
    <>
      <main className="page-wrapper">
        <HeaderOne
          btnStyle="btn-small round btn-icon"
          HeaderStyle="header-not-transparent"
        />
        {children}
        <FooterThree />
      </main>
    </>
  );
};
export default Layout;
